// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getDatabase } from "firebase/database";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAUNy8pFndrk7q2REiVCiHdwP2ZOoY2yMI",
  authDomain: "green-trees-85727.firebaseapp.com",
  projectId: "green-trees-85727",
  storageBucket: "green-trees-85727.appspot.com",
  messagingSenderId: "32908298802",
  appId: "1:32908298802:web:1731cff68390a2aaab4a2b",
  measurementId: "G-LRE39J029N",
  databaseURL: "https://green-trees-85727-default-rtdb.firebaseio.com"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app);
const firestore = getFirestore(app);
const database = getDatabase(app);
export { app, analytics, auth, firestore, database }; 
